import { styled } from "@mui/material/styles";
import clsx from "clsx";
import TextField, { TextFieldProps } from "designSystem/components/textfield/TextField";
import React, { FunctionComponent } from "react";

const PREFIX = "InlineTextField";

const classes = {
	textFieldClass: `${PREFIX}textFieldClass`,
};

const StyledTextField = styled(TextField)(({
	theme,
}) => ({
	[`&.${classes.textFieldClass}`]: (props: TextFieldProps) => ({
		"& .MuiInput-root": {
			"&::before": {
				content: `"${props.inputProps.value}"`,
				display: "inline",
				visibility: "hidden",
			},
			"& .MuiInput-input": {
				position: "absolute",
				width: "100%",
			},
		},
	}),
}));

export interface InlineTextFieldProps extends Omit<TextFieldProps, "variant"> {

}

const InlineTextField: FunctionComponent<InlineTextFieldProps> = (props) => {
	const { className, ...otherProps } = props;

	return (
		<StyledTextField
			{...otherProps}
			className={clsx(className, classes.textFieldClass)}
		/>
	);
};

export default InlineTextField;